jQuery(document).ready(function() {
	// Initialize dropdown behavior on calendar filters
	jQuery('.evt-filters__heading').on('click', filterDropdown);
});

// Click handler for filter dropdown functionality
function filterDropdown() {
	var $this = jQuery(this), // .evt-filters__heading
		$wrap = $this.parent(), // .evt-filters
		$inner = jQuery('.evt-filters__inner', $wrap);

	if (!$inner.length) {
		return;
	}

	if ($wrap.hasClass('evt-filters--expanded')) {
		$inner.stop().animate({'height' : 0 }, 250, function() {
			$wrap.removeClass('evt-filters--expanded');
			$inner.css('height', '');
		});
	} else {
		$wrap.addClass('evt-filters--expanded');
		$inner.stop().css('height', 'auto');
		var height = $inner.outerHeight();
		$inner.css('height', 0).animate({ 'height' : height }, 250, function() {
			$inner.css('height', ''); 
		});
	}

}